module.exports = __webpack_public_path__ + "static/media/YM64_3.10472161.jpg";